"use client";

import { useFetchApi } from "@/composables/useFetchApi";
import type { StrapiCollectionResponse, StrapiEntity, StrapiQuery, StrapiQueryValue } from "@/lib/strapi";
import type { PopupAttributes } from "@/services/popup";

export type UsePopupOptions = {
  enabled?: boolean;
  query?: StrapiQuery;
  populate?: StrapiQueryValue;
  withBrandFilter?: boolean;
  path?: string;
  initialData?: StrapiCollectionResponse<PopupAttributes> | null;
};

export function usePopup(options?: UsePopupOptions) {
  const query: StrapiQuery = {
    ...(options?.query ?? {}),
    filters: {
      ...(typeof options?.query?.filters === "object" && options?.query?.filters !== null
        ? (options.query.filters as Record<string, unknown>)
        : {}),
      is_active: { $eq: true },
    },
    sort: options?.query?.sort ?? ["updatedAt:desc"],
    pagination: options?.query?.pagination ?? { pageSize: 1 },
    populate: options?.populate !== undefined ? options.populate : (options?.query?.populate ?? "*"),
  };

  const state = useFetchApi<StrapiCollectionResponse<PopupAttributes>>(options?.path ?? "/pop-ups", {
    enabled: options?.enabled,
    query,
    withBrandFilter: options?.withBrandFilter ?? true,
    initialData: options?.initialData,
  });

  const popup: StrapiEntity<PopupAttributes> | null = state.data?.data?.[0] ?? null;

  return { ...state, popup };
}
